<template>
    <div id="cerfatva">
        <nav class="printableNo">
            <div class="leftNav">
                <div class="innerNav">
                    <img class="navLogout" v-on:click="logout()" src="/assets/logout.png" alt="logout" />
                </div>
            </div>
            <center>
                <img class="main" v-on:click="reload()" src="/assets/logo.png" alt="SO" />
            </center>
            <div class="rightNav">
                <div class="innerNav">
                    <span class="pNav">{{Name}}</span>
                    <img class="logoNav" src="/assets/adpr.png" alt="ADPR" />
                </div>
            </div>
        </nav>
        <div class="outermargin printableNo">
            <button v-on:click="backbtn()" class="btnBack">
                <font-awesome-icon icon="arrow-alt-circle-left" />
            </button>
        </div>
        <div class="pdfcontainer">
            <div v-if="numPages === 1">
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <div v-else>
                <pdf v-for="i in numPages" :key="i" :src="pdfLink" :page="i" class="pdfViewer"></pdf>
            </div>
            <img :src="sig" class="imgOverPdf" />
            <!-- client info -->
            <input class="nameOverPdf" v-model="cerfa.customerAddress.lastName" />
            <input class="customerFirstname fix-focus" v-model="cerfa.customerAddress.firstName" />
            <input class="customerStreetName fix-focus" v-model="cerfa.customerAddress.streetName" />
            <input class="customerCity fix-focus" v-model="cerfa.customerAddress.city" />
            <input class="customerPostalCode fix-focus" v-model="cerfa.customerAddress.postalCode" />
            <!-- client residence info -->
            <div class="accept individualHouse">
                <input type="checkbox" class="individualHouse fix-focus" id="immeubleIndividuel" value="maison ou immeuble individuel" v-model="cerfa.buildingType" />
                <label for="immeubleIndividuel"></label>
            </div>

            <div class="accept collectiveBuilding">
                <input type="checkbox" class="collectiveBuilding fix-focus" id="immeubleCollectif" value="immeuble collectif" v-model="cerfa.buildingType" />
                <label for="immeubleCollectif"></label>
            </div>

            <div class="accept collectiveAppartement">
                <input type="checkbox" class="collectiveAppartement fix-focus" id="appartementIndividuel" value="appartement individuel" v-model="cerfa.buildingType" />
                <label for="appartementIndividuel"></label>
            </div>
            <div class="accept otherBuildingType">
                <input v-if="cerfa.buildingType.length < 1 " type="checkbox" class="otherBuildingType fix-focus" id="otherBuildingType" value="otherBuildingType" v-model="otherBuildingType" />
                <label for="otherBuildingType"></label>
            </div>

            <input v-if="otherBuildingType" class="otherBuildingTypeInput fix-focus" v-model="cerfa.buildingType" />
            <!-- affected zone -->
            <div class="accept affectedZone0">
                <input type="checkbox" class="affectedZone0 fix-focus" id="affectedZone0" v-model="cerfa.affectedZone[0]" />
                <label for="affectedZone0"></label>
            </div>

            <div class="accept affectedZone1">
                <input type="checkbox" class="affectedZone1 fix-focus" id="affectedZone1" v-model="cerfa.affectedZone[1]" />
                <label for="affectedZone1"></label>
            </div>

            <div class="accept affectedZone2">
                <input type="checkbox" class="affectedZone2 fix-focus" id="affectedZone2" v-model="cerfa.affectedZone[2]" />
                <label for="affectedZone2"></label>
            </div>

            <div class="accept affectedZone3">
                <input type="checkbox" class="affectedZone3 fix-focus" id="affectedZone3" v-model="cerfa.affectedZone[3]" />
                <label for="affectedZone3"></label>
            </div>

            <input v-if="cerfa.affectedZone[2]" class="affectedZoneRadius fix-focus" v-model="cerfa.affectedZoneRadius" />

            <!-- intervention type -->
            <div class="accept isAffectingFondations">
                <input type="checkbox" class="isAffectingFondations fix-focus" id="isAffectingFondations" v-model="cerfa.isAffectingFondations" />
                <label for="isAffectingFondations"></label>
            </div>

            <!-- building info -->
            <input class="buildingStreetName fix-focus" v-model="cerfa.buildingAddress.streetName" />
            <input class="buildingCity fix-focus" v-model="cerfa.buildingAddress.city" />
            <input class="buildingPostalCode fix-focus" v-model="cerfa.buildingAddress.postalCode" />
            <!-- nature of the client -->

            <div class="accept isOwner">
                <input class="isOwner fix-focus" type="checkbox" id="isOwner" v-model="cerfa.isOwner" />
                <label for="isOwner"></label>
            </div>
            <div class="accept isTenant">
                <input class="isTenant fix-focus" type="checkbox" id="isTenant" v-model="cerfa.isTenant" />
                <label for="isTenant"></label>
            </div>
            <div class="accept isGuest">
                <input class="isGuest fix-focus" type="checkbox" id="isGuest" v-model="cerfa.isGuest" />
                <label for="isGuest"></label>
            </div>

            <input v-if="cerfa.isGuest" class="isGuestInput fix-focus" v-model="cerfa.guestType" />

            <!-- affecting element -->
            <div class="accept isAffectingElement0">
                <input type="checkbox" class="isAffectingElement0 fix-focus" id="isAffectingElement0" v-model="cerfa.isAffectingElement[0]" />
                <label for="isAffectingElement0"></label>
            </div>
            <div class="accept isAffectingElement1">
                <input type="checkbox" class="isAffectingElement1 fix-focus" id="isAffectingElement1" v-model="cerfa.isAffectingElement[1]" />
                <label for="isAffectingElement1"></label>
            </div>
            <div class="accept isAffectingElement2">
                <input type="checkbox" class="isAffectingElement2 fix-focus" id="isAffectingElement2" v-model="cerfa.isAffectingElement[2]" />
                <label for="isAffectingElement2"></label>
            </div>
            <div class="accept isAffectingElement3">
                <input type="checkbox" class="isAffectingElement3 fix-focus" id="isAffectingElement3" v-model="cerfa.isAffectingElement[3]" />
                <label for="isAffectingElement3"></label>
            </div>
            <div class="accept isAffectingElement4">
                <input type="checkbox" class="isAffectingElement4 fix-focus" id="isAffectingElement4" v-model="cerfa.isAffectingElement[4]" />
                <label for="isAffectingElement4"></label>
            </div>
            <div class="accept isAffectingElement5">
                <input type="checkbox" class="isAffectingElement5 fix-focus" id="isAffectingElement5" v-model="cerfa.isAffectingElement[5]" />
                <label for="isAffectingElement5"></label>
            </div>

            <!-- affecting structure -->
            <div class="accept isIncreasingSize">
                <input type="checkbox" class="isIncreasingSize fix-focus" id="isIncreasingSize" v-model="cerfa.isIncreasingSize" />
                <label for="isIncreasingSize"></label>
            </div>
            <div class="accept isBuildingGrowingUp">
                <input type="checkbox" class="isBuildingGrowingUp fix-focus" id="isBuildingGrowingUp" v-model="cerfa.isBuildingGrowingUp" />
                <label for="isBuildingGrowingUp"></label>
            </div>
            <div class="accept isUpgradingEnergy">
                <input type="checkbox" class="isUpgradingEnergy fix-focus" id="isUpgradingEnergy" v-model="cerfa.isUpgradingEnergy" />
                <label for="isUpgradingEnergy"></label>
            </div>

            <!-- low tva -->
            <div class="accept isLowTVAcompliant">
                <input type="checkbox" class="isLowTVAcompliant fix-focus" id="isLowTVAcompliant" v-model="cerfa.isLowTVAcompliant" />
                <label for="isLowTVAcompliant"></label>
            </div>

            <!-- signature -->
            <input class="signatureCity fix-focus" v-model="cerfa.signatureCity" />
            <input class="signatureTimestamp fix-focus" type="date" v-model="cerfa.signatureTimestamp" />
        </div>
        <div class="outercircle printableNo">
            <span class="sigBot">Signature :</span>
            <VueSignaturePad width="400px" height="150px" :class="sigpadclass" ref="signaturePad" />
            <button class="docBtn" :title="title" type="button" :disabled="validated" v-on:click="validatePDF()">Valider et enregistrer le Cerfa</button>
            <button class="docBtn2" :title="title2" type="button" :disabled="!validated" v-on:click="print()">Télécharger le Cerfa en PDF</button>
        </div>
    </div>
</template>

<script>
import pdf from 'vue-pdf';
import axios from 'axios';

export default {
    name: 'Cerfatva',
    components: {
        pdf
    },
    data() {
        return {
            Name: "client",
            cerfa: {
                customerAddress: {
                    streetNb: "",
                    streetName: "",
                    postalCode: "",
                    city: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    company: "",
                    emailAddress: ""
                },


                buildingType: [],
                buildingArchitectureType: "",
                buildingAddress: {
                    streetNb: "",
                    streetName: "",
                    postalCode: "",
                    city: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    company: "",
                    emailAddress: ""
                },
                homestead: "",
                isOwner: false,
                isTenant: false,
                isGuest: false,
                guestType: "",
                affectedZone: [false, false, false, false],
                isAffectingFondations: false,
                isAffectingElement: [false, false, false, false, false, false],
                isIncreasingSize: false,
                isBuildingGrowingUp: false,
                isUpgradingEnergy: false,
                isLowTVAcompliant: false,
                signatureTimestamp: "",
                signatureCity: "",
                status: "à remplir"
            },
            inquiry: {},
            pdfLink: "/assets/tva.pdf",
            sig: "/assets/nosignature.png",
            numPages: 1,
            validated: false,
            navWidth: 0,
            navMenuVisible: false,
            sigpadclass: "signature",
            files: [],
            title: "Valider le Cerfa",
            title2: "Veuillez valider le Cerfa afin de l'enregistrer",
            otherBuildingType: false
        };
    },
    methods: {
        reload() {
            this.$cookie.set('currentAriane', "");
            this.$cookie.set('history', "");
            this.$cookie.set('historyQuery', "");
            this.$router.replace({ name: "techhome" });
        },
        validatePDF() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
            if (isEmpty) {
                alert("Vous devez signer le document pour le valider");
            }
            else {
                this.sig = data;
                this.putTVAsheet();
            }
        },
        print() {
            window.print();
        },
        logout() {
            this.$cookie.delete('jwt');
            this.$cookie.delete('role');
            this.$cookie.delete('firstName');
            this.$cookie.delete('lastName');
            this.$cookie.delete('currentAriane');
            this.$cookie.delete('history');
            this.$cookie.delete('historyQuery');
            this.$router.replace({ name: "login" });
        },
        backbtn() {

            var strHist = this.$cookie.get('history');
            var arrHist = JSON.parse(strHist);
            var strQuery = this.$cookie.get('historyQuery');
            var arrQuery = JSON.parse(strQuery);

            this.$cookie.set('history', JSON.stringify(arrHist.slice(0, -1)));
            this.$cookie.set('historyQuery', JSON.stringify(arrQuery.slice(0, -1)));

            if (arrHist.length) {
                if (arrQuery[arrQuery.length - 1] !== "" && arrQuery[arrQuery.length - 1] !== "undefined") {
                    this.$router.replace({ name: arrHist[arrHist.length - 1], query: { name: arrQuery[arrQuery.length - 1] } });
                }
                else {
                    this.$router.replace({ name: arrHist[arrHist.length - 1] });
                }
            }
            else {
                this.$cookie.set('currentAriane', "");
                this.$router.replace({ name: "techhome" });
            }
        },
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, { type: mime });
        },
        async putSignature(idCerfa) {
            var file = this.dataURLtoFile(this.sig, 'picture.png');
            const fd = new FormData();
            fd.append('picture', file, "picture.png");

            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/tva/' + this.inquiry.name + '/' + idCerfa, fd)
            console.log(response);
            if (response) {
                this.validated = true;
                this.title = "Cerfa dejà validé";
                this.title2 = "Enregistrer le Cerfa";
                this.sigpadclass = "signaturedisable";
                this.$refs.signaturePad.lockSignaturePad()
                console.log("cerfa validé !");
            }
        },
        async putTVAsheet() {
            delete this.cerfa._id;
            var response = await axios.put('https://so.gaviota.fr/api/building/inquiry/tva/' + this.inquiry.name, { cerfa: this.cerfa })
            console.log(response);
            if (response) {
                this.putSignature(response.data.id);
            }
        },
        async getInquiries(){
            var nameInq = this.$route.query.name.split('/').join('%2F');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/'+nameInq)
            if(response.data.inquiry){
                this.inquiry = response.data.inquiry;
                if (this.inquiry.fioulsheet) {
                    this.getCerfa(this.inquiry.fioulsheet._id);
                }
            }
        },
        async getInquiry(id) {
            axios.defaults.headers.common['Authorization'] = this.$cookie.get('jwt');
            var response = await axios.get('https://so.gaviota.fr/api/building/inquiry/fromintervention/' + id);
            if (response.data.inquiry) {
                this.inquiry = response.data.inquiry;
                if (this.inquiry.TVAsheet) {
                    this.getCerfa(this.inquiry.TVAsheet._id);
                }
            }
        },
        async getCerfa(id) {
            var response = await axios.get('https://so.gaviota.fr/api/building/tva/' + id)
            if (response.data.cerfa) {
                this.cerfa = response.data.cerfa;
                console.log(response.data);
                if (this.cerfa) {
                    if (this.cerfa.status === "signé" && this.cerfa.signature) {
                        this.validated = true;
                        this.title = "Cerfa dejà validé";
                        this.title2 = "Enregistrer le cerfa";
                        this.sigpadclass = "signaturedisable";

                        this.sig = 'data:' + this.cerfa.signature.img.contentType + ';base64,' + btoa(
                            new Uint8Array(this.cerfa.signature.img.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                        );
                        this.$refs.signaturePad.fromDataURL(this.sig)
                        this.$refs.signaturePad.lockSignaturePad()
                    }
                    if(this.$cookie.get('role') === "admin" && this.$cookie.get('reloaded') === "false"){
                        this.$cookie.set('reloaded', "true");
                        location.reload();
                    }
                }
            }
        },
        getCookies: function () {
            if (!this.$cookie.get('jwt') || !this.$cookie.get('role') || this.$cookie.get('role') === "client" || !this.$route.query.name) {
                this.logout();
            }
            else {
                this.Name = this.$cookie.get('firstName') + " " + this.$cookie.get('lastName');

                if(this.$cookie.get('role') !== "admin"){
                    this.getInquiry(this.$route.query.name);
                }
                else{
                    this.getInquiries();
                }
            }
        },
    },

    mounted() {
        this.getCookies();
    }
}
</script>



<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=BenchNine");

#cerfatva {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    background-color: #f0f0f0;
    margin: auto;
    border: none;
}
h1 {
    background-color: #1ce83e;
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    padding-bottom: 15px;
    padding-top: 15px;
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    display: block;
    text-align: center;
    position: relative;
}
h2 {
    border-bottom: 2px solid;
    border-color: #1ce83e;
    color: black;
}
nav {
    top: 0px;
    left: 0px;
    right: 0px;
    margin: 0px;
    position: fixed;
    z-index: 11;
    width: 100%;
    background-color: white;
    border-bottom: 2px solid;
    border-color: #1ce83e;
}
.main {
    display: inline-block;
    cursor: pointer;
    margin: 5px;
}
.rightNav {
    position: absolute;
    top: 0;
    right: 0;
}
.innerNav {
    display: inline-block;
    position: relative;
}
.logoNav {
    vertical-align: middle;
    margin: 5px;
}
.navLogout {
    height: 20px;
    vertical-align: middle;
    cursor: pointer;
    margin: 24px;
}
.leftNav {
    position: absolute;
    top: 0;
    left: 0;
}
.pNav {
    display: inline-block;
    padding-right: 15px;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    vertical-align: middle;
}
@media screen and (max-width: 768px) {
    .pNav {
        display: none;
    }
}
.homeName {
    margin: auto;
    font-family: "BenchNine", sans-serif;
    font-size: 20px;
    text-align: center;
    margin: 10px;
}
#circle {
    width: 10px;
    height: 10px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    background: #1ce83e;
    margin: auto;
}
.outermargin {
    background-color: #f0f0f0;
    padding: 15px;
}
.btnBack {
    border: none;
    cursor: pointer;
    display: inline-block;
    font-size: 30px;
    margin-top: 80px;
    margin-left: 50px;
    background-color: #f0f0f0;
}
//TODO: uncomment border tribute
.pdfcontainer {
    width: 800px;
    margin: auto;
    position: relative;
    .customerFirstname {
        position: absolute;
        bottom: 895px;
        right: 230px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerStreetName {
        position: absolute;
        bottom: 880px;
        left: 145px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .customerCity {
        position: absolute;
        bottom: 880px;
        left: 420px;
        font-size: 14px;
        background-color: transparent;
        width: 136px;
        border: 0px solid;
    }
    .customerPostalCode {
        position: absolute;
        bottom: 880px;
        right: 100px;
        font-size: 14px;
        background-color: transparent;
        width: 80px;
        border: 0px solid;
    }
    .individualHouse {
        position: absolute;
        bottom: 795px;
        left: 101px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .collectiveBuilding {
        position: absolute;
        bottom: 795px;
        left: 330px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .collectiveAppartement {
        position: absolute;
        bottom: 795px;
        right: 261px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .affectedZone0 {
        position: absolute;
        bottom: 735px;
        left: 103px;
        font-size: 14px;
        background-color: transparent;
    }
    .affectedZone1 {
        position: absolute;
        bottom: 715px;
        left: 102px;
        font-size: 14px;
        background-color: transparent;
    }
    .affectedZone2 {
        position: absolute;
        bottom: 695px;
        left: 102px;
        font-size: 14px;
        background-color: transparent;
    }
    .affectedZone3 {
        position: absolute;
        bottom: 665px;
        left: 102px;
        font-size: 14px;
        background-color: transparent;
    }
    .affectedZoneRadius {
        position: absolute;
        bottom: 695px;
        right: 100px;
        width: 60px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .otherBuildingType {
        position: absolute;
        bottom: 775px;
        left: 101px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .otherBuildingTypeInput {
        position: absolute;
        bottom: 775px;
        left: 370px;
        font-size: 14px;
        background-color: transparent;
        width: 220px;
        border: 0px solid;
    }

    .isAffectingFondations {
        position: absolute;
        bottom: 550px;
        left: 102px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .buildingStreetName {
        position: absolute;
        bottom: 645px;
        left: 150px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .buildingCity {
        position: absolute;
        bottom: 645px;
        left: 400px;
        width: 130px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .buildingPostalCode {
        position: absolute;
        bottom: 645px;
        right: 105px;
        width: 100px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }
    .isOwner {
        position: absolute;
        bottom: 625px;
        left: 162px;
        font-size: 14px;
        background-color: transparent;
    }
    .isTenant {
        position: absolute;
        bottom: 625px;
        left: 243px;
        font-size: 14px;
        background-color: transparent;
    }
    .isGuest {
        position: absolute;
        bottom: 625px;
        left: 330px;
        font-size: 14px;
        background-color: transparent;
    }
    .isGuestInput {
        position: absolute;
        bottom: 625px;
        left: 480px;
        font-size: 14px;
        background-color: transparent;
        border: 0px solid;
    }

    .isAffectingElement0 {
        position: absolute;
        bottom: 510px;
        left: 370px;
        font-size: 14px;
        background-color: transparent;
    }
    .isAffectingElement1 {
        position: absolute;
        bottom: 498px;
        left: 150px;
        font-size: 14px;
        background-color: transparent;
    }
    .isAffectingElement2 {
        position: absolute;
        bottom: 498px;
        left: 268px;
        font-size: 14px;
        background-color: transparent;
    }
    .isAffectingElement3 {
        position: absolute;
        bottom: 498px;
        left: 375px;
        font-size: 14px;
        background-color: transparent;
    }
    .isAffectingElement4 {
        position: absolute;
        bottom: 498px;
        right: 191px;
        font-size: 14px;
        background-color: transparent;
    }
    .isAffectingElement5 {
        position: absolute;
        bottom: 485px;
        left: 102px;
        font-size: 14px;
        background-color: transparent;
    }
    .isIncreasingSize {
        position: absolute;
        bottom: 460px;
        left: 103px;
        font-size: 14px;
        background-color: transparent;
    }
    .isBuildingGrowingUp {
        position: absolute;
        bottom: 447px;
        left: 103px;
        font-size: 14px;
        background-color: transparent;
    }
    .isUpgradingEnergy {
        position: absolute;
        bottom: 435px;
        left: 103px;
        font-size: 14px;
        background-color: transparent;
    }
    .isLowTVAcompliant {
        position: absolute;
        bottom: 384px;
        left: 103px;
        font-size: 14px;
        background-color: transparent;
    }
    .signatureCity {
        position: absolute;
        bottom: 165px;
        left: 365px;
        font-size: 14px;
        background-color: transparent;
        width: 115px;
        border: 0px solid;
    }
    .signatureTimestamp {
        position: absolute;
        bottom: 160px;
        right: 140px;
        font-size: 15px;
        background-color: transparent;
        border: 0px solid;
    }
    .accept {
        margin-bottom: 20px;
        input[type="checkbox"] {
            display: none;
        }
        input[type="checkbox"] + label {
            display: block;
            position: relative;
            padding-left: 35px;
            margin-bottom: 20px;
            font-size: 0.9rem;
            cursor: pointer;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }
        input[type="checkbox"] + label:last-child {
            margin-bottom: 0;
        }
        input[type="checkbox"] + label:before {
            content: "";
            display: block;
            width: 8px;
            height: 8px;
            // border: 2px solid black;
            position: absolute;
            left: 6px;
            top: 6px;
            -webkit-transition: all 0.12s, border-color 0.08s;
            transition: all 0.12s, border-color 0.08s;
        }
        input[type="checkbox"]:checked + label:before {
            width: 10px;
            top: 0px;
            left: 5px;
            border-radius: 0;
            border: 2px solid black;

            opacity: 1;
            border-top-color: transparent;
            border-left-color: transparent;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
        }
    }
}
.fix-focus:focus {
    outline: none;
}
.pdfViewer {
    width: 100%;
}
.imgOverPdf {
    position: absolute;
    bottom: 115px;
    right: 130px;
    width: 128px;
    height: 48px;
}
.nameOverPdf {
    position: absolute;
    bottom: 895px;
    left: 137px;
    font-size: 14px;
    background-color: transparent;
    border: 0px solid;
}
.nameOverPdf:focus {
    outline: none;
}
.outercircle {
    background-color: #f0f0f0;
    padding: 50px;
    width: 800px;
    margin: auto;
    position: relative;
}
.docBtn {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 107px;
    right: 0px;
}
.docBtn2 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-right: 100px;
    width: 200px;
    position: absolute;
    top: 166px;
    right: 0px;
}
.docBtn3 {
    font-family: "BenchNine", sans-serif;
    font-stretch: ultra-condensed;
    display: inline-block;
    border: none;
    color: #1ce83e;
    font-size: 18px;
    cursor: pointer;
    background-color: black;
    border-radius: 10px;
    margin: 0px;
    margin-bottom: 50px;
    margin-left: 100px;
    width: 200px;
    position: absolute;
    top: 30px;
    left: 250px;
}
button:disabled,
button[disabled] {
    border: 1px solid #999999;
    background-color: #cccccc;
    color: #666666;
    cursor: no-drop;
}
@media print {
    .printableNo {
        display: none;
    }
}
@page {
    size: auto;
    margin: 0mm;
}
.sideNav {
    background-clip: border-box;
    background-color: #fff;
    background-origin: padding-box;
    box-sizing: border-box;
    background-color: #333;
    display: block;
    height: 100%;
    overflow: auto;
    box-shadow: 8px 0px 6px -6px #999;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navsidecontent {
    color: white;
    font-family: "BenchNine", sans-serif;
    margin-top: 65px;
    margin-left: 30px;
    margin-right: 30px;
    -webkit-transition: width 0.5s;
    transition: width 0.5s;
}
.navtitle {
    margin: 10px;
    margin-top: 15px;
    padding-top: 5px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    border-top: 1px solid;
    border-color: #eee;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: default;
}
.navsubtitle {
    margin: 7px;
    font-size: 18px;
    font-weight: 400;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: pointer;
}
.navsubtitle:hover {
    color: #999;
}
.noborder {
    border: none;
    margin-top: 5px;
    padding-top: 0px;
}
.logout {
    padding-top: 50px;
    cursor: pointer;
}

/* width */
::-webkit-scrollbar {
    width: 6px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #ddd;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
}
.signature {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: white;
}
.signaturedisable {
    display: inline-block;
    border: 2px solid;
    border-color: #888;
    background-color: #cccccc;
    cursor: no-drop;
}
.sigBot {
    font-family: "BenchNine", sans-serif;
    display: block;
    font-size: 18px;
}
</style>